import Vue from 'vue';
import Vuex from 'vuex';
import axios from "../axios";
import * as TYPES from './types';
import task from './modules/task';
import balanceSheet from './modules/balance-sheet';
import profit from './modules/profit';
import cashflow from './modules/cashflow';
import contract from './modules/contract';
import receiptCount from './modules/receipt-count';
import company from './modules/company';
import taxFiling from './modules/tax-filing';
import balances from './modules/balances';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    showLoading: false,//是否显示loading,
    errorText: '',//错误信息
    companies: [],//dropdown list公司
    industries: [],//行业
    provinces: [],
    cities: {},
    areas: {},
    taxTypes: [],//税务性质
  },
  getters: {
    showLoading: state => state.showLoading,
    errorText: state => state.errorText,
    industries: state => state.industries,
    provinces: state => state.provinces,
    taxTypes: state => state.taxTypes,
    miniCompanies: state => state.companies.map(c => {
      return {value: c.companyId, text: c.name};
    }),
  },
  mutations: {
    [TYPES.SET_LOADING](state, payload) {
      state.showLoading = payload;
    },
    [TYPES.SET_ERROR](state, payload) {
      state.errorText = payload;
    },
    [TYPES.SET_COMPANIES](state, payload) {
      state.companies = payload;
    },
    [TYPES.SET_INDUSTRIES](state, payload) {
      state.industries = payload;
    },
    setProvinces(state, provinces) {
      state.provinces = provinces;
    },
    setCities(state, {province, cities}) {
      state.cities[province] = cities;
    },
    setAreas(state, {province, city, areas}) {
      state.areas[province + "," + city] = areas;
    },
    setTaxTypes(state, taxTypes) {
      state.taxTypes = taxTypes;
    },
  },
  actions: {
    setLoading: ({commit}, flag) => {
      commit(TYPES.SET_LOADING, flag)
    },
    setError: ({commit}, text) => {
      commit(TYPES.SET_ERROR, text);
    },
    fetchMiniCompanies: ({commit}, role) => {
      let url = '';
      if (role === 'user') {
        url = 'me';
      } else {
        url = 'minimum';
      }

      axios
        .get("/companies/" + url)
        .then(response => {
          let dataArr = [];
          if (role === 'user') {
            dataArr.push(response.data);
          } else {
            dataArr = response.data;
          }
          commit(TYPES.SET_COMPANIES, dataArr);
        })
        .catch(() => {
        });
    },
    fetchIndustries: ({commit}) => {
      axios
        .get("/lookups/company/industries")
        .then(response => {
          commit(TYPES.SET_INDUSTRIES, response.data);
        })
        .catch(() => {
        });
    },


    fetchProvinces({commit}, cb) {
      axios
        .get("/provinces")
        .then(response => {
          let results = response.data;
          commit("setProvinces", results);
          if (cb) {
            cb(results);
          }
        })
        .catch(() => {
        });
    },
    fetchCities({state, commit}, {province, callback}) {
      if (province in state.cities) {
        callback(state.cities[province]);
      } else {
        axios
          .get("/provinces/" + province + "/cities")
          .then(response => {
            let results = response.data;
            commit("setCities", {province: province, cities: results});
            if (callback) {
              callback(results);
            }
          })
          .catch(() => {
          });
      }
    },
    fetchAreas({state, commit}, {province, city, callback}) {
      let key = province + "," + city;
      if (key in state.areas) {
        callback(state.areas[key]);
      } else {
        axios
          .get("/provinces/" + province + "/cities/" + city + "/areas")
          .then(response => {
            let results = response.data;
            commit("setAreas", {
              province: province,
              city: city,
              areas: results
            });
            if (callback) {
              callback(results);
            }
          })
          .catch(() => {
          });
      }
    },
    fetchTaxTypes({commit}) {
      axios
        .get("/lookups/company/tax-types")
        .then(response => {
          let results = response.data;
          commit("setTaxTypes", results);
        })
        .catch(() => {
        });
    },
  },
  modules: {
    task,
    balanceSheet,
    profit,
    cashflow,
    contract,
    receiptCount,
    company,
    taxFiling,
    balances
  }
})